import qs from "qs";
import axios from "utils/axios";

import { API } from "constants/";

// Type
import { AxiosResponse } from "axios";
import { TenureChartPayload, TenureChartResponse } from "./tenureChart.types";

export const getTenureChartService = (params: TenureChartPayload): Promise<AxiosResponse<TenureChartResponse>> => {
    const { person_ids, ...requestParams } = params;
    return axios.post(`${API.LEADERSHIP.TENURE_CHART}?${qs.stringify(requestParams, { arrayFormat: "repeat" })}`, {
        person_ids,
    });
};
